export default __webpack_public_path__ + "media/7c93dc679537263169eddc54b118a5292c2542929ca250c89455a3becf441dba.svg";